import React from 'react';
import { Button, Dropdown, Icon, Skeleton } from '@fourthwall/components';
import { ChevronDownIcon } from '@fourthwall/icons';
import { calculateValuePercentageChange } from '../../../../utils/calculateValuePercentageChange';
import { AnalyticsChangeIndicator } from '../../../AnalyticsChangeIndicator/AnalyticsChangeIndicator';
import { AnalyticsExternalSourceIcon } from '../../../AnalyticsExternalSourceIcon/AnalyticsExternalSourceIcon';
import { HeadLabelTooltip } from '../../../AnalyticsTable/components/HeadLabelTooltip/HeadLabelTooltip';
import { AnalyticsTooltip } from '../../../AnalyticsTooltip/AnalyticsTooltip';
import * as S from './AnalyticsCardHeading.styled';
export const AnalyticsCardHeading = ({ type, header, externalSource, subtitle, value, formatValue, reportLink, isLoading, }) => {
    const displayValue = (value) => (formatValue ? formatValue(value) : value);
    const hasDropdown = !!header.options?.length && !!header.onOptionSelect;
    if (isLoading) {
        return React.createElement(AnalyticsCardHeadingSkeleton, { type: type });
    }
    const renderValue = () => {
        if (value === undefined) {
            return null;
        }
        const hasComparableValue = Array.isArray(value);
        if (hasComparableValue) {
            const changeValue = calculateValuePercentageChange(value);
            return (React.createElement(React.Fragment, null,
                React.createElement(S.Value, null, displayValue(value[0])),
                React.createElement(AnalyticsChangeIndicator, { value: changeValue, showZero: false })));
        }
        return React.createElement(S.Value, null, displayValue(value));
    };
    const getReportLinkProps = () => {
        if (!reportLink)
            return null;
        if (typeof reportLink === 'object' && 'to' in reportLink) {
            return { to: reportLink.to, state: reportLink.state };
        }
        return { to: reportLink };
    };
    const reportLinkProps = getReportLinkProps();
    const renderHeaderLabel = () => {
        if (header.tooltip) {
            return (React.createElement(AnalyticsTooltip, { content: React.createElement(HeadLabelTooltip, { ...header.tooltip }) },
                React.createElement(S.HeaderLabel, { underline: !!header.tooltip, isDropdownTrigger: hasDropdown }, header.label)));
        }
        return (React.createElement(S.HeaderLabel, { underline: !!header.tooltip, isDropdownTrigger: hasDropdown }, header.label));
    };
    const renderHeaderLabelContent = () => {
        if (hasDropdown) {
            return (React.createElement(Dropdown, { content: header.options?.map((option) => (React.createElement(Dropdown.Item, { key: option.value, label: option.label, onClick: () => header.onOptionSelect?.(option.value) }))), position: "bottom-start" },
                React.createElement(S.DropdownContent, null,
                    renderHeaderLabel(),
                    React.createElement(S.DropdownButton, null,
                        React.createElement(Icon, { component: ChevronDownIcon, height: 14 })))));
        }
        return renderHeaderLabel();
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Content, null,
            React.createElement(S.HeaderContainer, null,
                React.createElement(S.HeaderLabelWrapper, null,
                    React.createElement(AnalyticsExternalSourceIcon, { externalSource: externalSource }),
                    renderHeaderLabelContent()),
                React.createElement(S.Subtitle, null, subtitle)),
            reportLinkProps && (React.createElement(Button, { appearance: "secondary", size: "xsmall", label: "Full report", ...reportLinkProps }))),
        React.createElement(S.ValueContainer, null, renderValue())));
};
const AnalyticsCardHeadingSkeleton = ({ type }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Content, null,
            React.createElement(S.HeaderContainer, null,
                React.createElement(S.HeaderLabelWrapper, null,
                    React.createElement(Skeleton.Shape, { width: 200, height: 24 })),
                type === 'stats' && (React.createElement(S.Subtitle, null,
                    React.createElement(Skeleton.Shape, { width: 140, height: 20 })))),
            React.createElement(Skeleton.Shape, { width: 110, height: 32 })),
        React.createElement(S.ValueContainer, null, type === 'lineChart' && (React.createElement(S.Value, null,
            React.createElement(Skeleton.Shape, { width: 120, height: 36 }))))));
};
